import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { DwSecurityUserService } from '@devwareapps/devware-cap';
import { AppPermissions } from '../../../meta-data/app-permissions.enum';

/** Matches the existing Streaker Admin Access CAP security group. */
@Injectable({ providedIn: 'root' })
export class CentralAdminAccessService implements CanActivate {
    constructor(private _security: DwSecurityUserService, private _router: Router) {}

    get allowed(): boolean {
        return this._security.hasPermission('Streaker_Admin_CanAccess')
            || this._security.hasPermission(AppPermissions.entAdminCanAccess);
    }

    canActivate(): boolean | UrlTree {
        return this.allowed || this._router.createUrlTree(['/streaker-central']);
    }
}
